import React from 'react';
import styled from 'styled-components'
import AnimatedGif from '../AnimatedGif'
const FullwidthGifWrapper = styled.div`
    img {
        width: 100%;
    }
`
const FullwidthGif = ({src, altText}) => {
  return (
      <FullwidthGifWrapper className="row-component">
          <AnimatedGif src={src} altText={altText} />
      </FullwidthGifWrapper>
  )
};

export default FullwidthGif;
